import { getProductApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    CreateProductRequest,
    GetAllProductsResponse,
    ProductApiGetAllProductsRequest,
    ProductResponse,
    ProductForOrderResponse,
    UpdateProductRequest,
} from '@/core/generated/api';

/** Выполняет операции с продуктами через API */
export const productService = {
    /** Загружает список продуктов */
    async getList(request: ProductApiGetAllProductsRequest): Promise<GetAllProductsResponse> {
        try {
            const response = await getProductApi().getAllProducts(request);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает совместимые дополнительные продукты */
    async getCompatibleAdditionalProducts(productId: string): Promise<ProductForOrderResponse[]> {
        try {
            const response = await getProductApi().getAdditionalProductsForOrder({ productId });

            return response.data.additionalOfferedProducts ?? [];
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает продукт по идентификатору */
    async getById(id: string): Promise<ProductResponse> {
        try {
            const response = await getProductApi().getProductById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт продукт */
    async create(data: CreateProductRequest): Promise<ProductResponse> {
        try {
            const response = await getProductApi().createProduct({ createProductRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет продукт */
    async update(data: UpdateProductRequest): Promise<ProductResponse> {
        try {
            const response = await getProductApi().updateProduct({ updateProductRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Деактивирует продукт */
    async deactivate(id: string, comment?: string): Promise<void> {
        try {
            await getProductApi()
                .apiV1ProductsIdDelete({
                    id,
                    deleteRequest: { comment }
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
